<template>

  <div class="inner-box">

    <div class="grid-wrap">
      <ag-grid-vue ref="agentGrid"
                   style="width: 100%; height: 40vh;"
                   class="ag-theme-alpine grid_search_height"
                   :enableRangeSelection="true"
                   :columnDefs="columnDefs"
                   :gridOptions="gridOptions"
                   :rowData="data"
                   :defaultColDef="defaultColDef"
                   :frameworkComponents="frameworkComponents"
                   @grid-ready="onReadyAgent"
                   @cell-clicked="onCellClickedAgent"
      />
    </div>

    <el-form size="mini" :model="form" ref="catInfoForm" class="components">

      <el-row>
        <el-col>
          <el-col :span="2">
            <el-form-item label="ID" v-if=" form.userId === '' ">
              <el-input v-model="form.userId" v-show="false"></el-input>
              <el-input v-model="form.asAgentId" v-show="false"></el-input>
              <el-input v-model="form.userCd"></el-input>
            </el-form-item>
            <el-form-item label="ID" v-else>
              <el-input v-model="form.userId" v-show="false"></el-input>
              <el-input v-model="form.asAgentId" v-show="false"></el-input>
              <el-input v-model="form.userCd" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="그룹구분">
              <el-select v-model="form.groupUid">
                <el-option value='' key=''  label="">선택</el-option>
                <el-option :value='5' :key='5'  label="AS기사">AS기사</el-option>
                <el-option :value='6' :key='6'  label="센터관리자">센터관리자</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="직급" prop="catNm">
              <el-input v-model="form.positionCd"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="성명" prop="catNm">
              <el-input v-model="form.userNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="차량번호" prop="catNm">
              <el-input v-model="form.carNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="입사일자" prop="catNm">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.enterDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="담당지역" prop="catNm">
              <el-input v-model="form.area"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="휴대폰" prop="catNm">
              <el-input v-model="form.hpNo"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
      <el-form-item label="평일" style="color: red;">
        <el-row>
          <el-col>
            <el-col :span="4">
              <el-form-item label="오전">
                <el-input v-model="form.weekMorning"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="오후" prop="catNm">
                <el-input v-model="form.weekAfterNoon"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form-item>
      </el-row>

      <el-row>
      <el-form-item label="토요일" style="color: red;">
        <el-row>
          <el-col>
            <el-col :span="4">
              <el-form-item label="오전">
                <el-input v-model="form.weekEndMorning"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="오후" prop="catNm">
                <el-input v-model="form.weekEndAfterNoon"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form-item>
      </el-row>

    </el-form>
  </div>

</template>

<script>
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

export default {
  name: "AgentInfo",
  props: ['custParam','selectId'],
  data() {
    return {
      form: {
        userCd: "",
        groupUid: "",
        positionCd: "",
        userNm: "",
        carNo: "",
        enterDt: "",
        weekMorning: "",
        weekAfterNoon: "",
        weekEndMorning: "",
        weekEndAfterNoon: "",
        userId: "",
        addr1:"",
        addr2:"",
        area:"",
        asAgentFullNm:"",
        asAgentId:"",
        asAgentNm:"",
        asAgentType:"",
        businessNo:"",
        businessStatus:"",
        businessType:"",
        companyId:"",
        contractEndDt:"",
        contractStartDt:"",
        contractStatus:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        email:"",
        friAfterNoonYn:"",
        friMorningYn:"",
        guaranteeInsurance:"",
        hpNo:"",
        keyManNm:"",
        monAfterNoonYn:"",
        monMorningYn:"",
        satAfterNoonYn:"",
        satMorningYn:"",
        sunAfterNoonYn:"",
        sunMorningYn:"",
        telNo:"",
        territory:"",
        thuAfterNoonYn:"",
        thuMorningYn:"",
        tueAfterNoonYn:"",
        tueMorningYn:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        wedAfterNoonYn:"",
        wedMorningYn:"",
        zipCd:"",
      },
      // eslint-disable-next-line vue/no-dupe-keys
      tapName: "default",
      columnDefs: [],
      data: [],
      gridOptions: {},
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      frameworkComponents: null,
    };
  },
  methods: {
    setInfo() {
      Object.assign(this.form, this.custParam);
    },
    defaultInfo(){
      this.tapName = "default";
    },
    agentInfo(){
      this.tapName = "agent";
    },
    timeTableInfo(){
      this.tapName = "time";
    },
    onReadyAgent(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

    },
    onCellClickedAgent(params) {
      this.gridApi = this.gridOptions.api;
      this.columnApi = this.gridOptions.columnApi;
      const voRow = params.data //선택된 Row
      this.$http
          .post("/api/asAgentMng/detail/agent/item", {
            companyId: this.$store.state.loginInfo.compCd,
            userId: voRow.userId,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              this.form = response.data[0];
            }
          }).finally(() => {
      });
    },
    createColumnDefs() {
      const vm = this;

      this.columnDefs = [
        {
          headerName: '선택'
          , field:'regYn'
          , width : 50
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "1"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "0"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName:'ID', field:'userCd', width:50, editable:false},
        {headerName:'그룹구분', field:'groupNm', width:80, editable:false},
        {headerName:'직급', field:'positionCd',  width:80, editable:false},
        {headerName:'성명', field:'userNm',  width:40, editable:false},
        {headerName:'차량번호', field:'carNo',  width:40, editable:false},
        {headerName:'입사일자', field:'enterDt',  width:40, editable:false,
          valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`)
          }
        },
        {headerName:'담당지역', field:'area',  width:40, editable:false},
        {headerName:'휴대폰', field:'hpNo', width:40, editable:false},
        {headerName:'삭제여부', field:'deleteYn', width:40, editable:false,
          cellStyle:{color: 'red'},
          valueFormatter: function(params) {
            return params.value == 'Y' ? '삭제' : '';
          }},
        {
          headerName: '평일', children: [
            {headerName: '오전', field: 'weekMorning', width: 50, editable: false},
            {headerName: '오후', field: 'weekAfterNoon', width: 50, editable: false},
          ], width: 100, editable: false
        },
        {
          headerName: '토요일', children: [
            {headerName: '오전', field: 'weekEndMorning', width: 50, editable: false},
            {headerName: '오후', field: 'weekEndAfterNoon', width: 50, editable: false},
          ], width: 100, editable: false
        },
        {headerName:'', field:'userId', hide : true}
      ]

    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그리드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {

  },
  watch: {
    custParam() {
      this.setInfo();
      this.data = this.custParam;
    },
    selectId(){
      this.setInfo();
      this.createColumnDefs();
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}

.el-row {
  border-bottom: 1px solid #d7d7d7;
  &:last-child {
    border-bottom: none;
  }
}

.el-form {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 25px 10px 25px;
  border-radius: 5px;
}
</style>